export default "__VITE_ASSET__B38WTTLD__"